"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const unilib_error_1 = __importDefault(require("unilib-error"));
const WILDCARD = '*';
class UDispatcher {
    constructor() {
        this.__ = {};
    }
    register(name, handler) {
        if (typeof name !== 'string' || (name = name.trim()) === '') {
            throw new unilib_error_1.default(`${this.constructor.name}.register/INVALID_HANDLER_NAME`, { context: { name } });
        }
        if (typeof handler !== 'function') {
            throw new unilib_error_1.default(`${this.constructor.name}.register/INVALID_HANDLER`, {
                context: { handler }
            });
        }
        this.__[name] = handler;
    }
    canDispatch(name) {
        return Boolean(this._getHandler(name));
    }
    _getHandler(name) {
        for (const _name of Object.keys(this.__)) {
            if (_name === name ||
                (_name.endsWith(WILDCARD) && name.startsWith(_name.slice(0, -1)))) {
                return this.__[_name];
            }
        }
    }
    dispatch(name, ...parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof name !== 'string' ||
                (name = name.trim()) === '' ||
                name.endsWith(WILDCARD)) {
                throw new unilib_error_1.default(`${this.constructor.name}.dispatch/INVALID_HANDLER_NAME`, { context: { name } });
            }
            const handler = this._getHandler(name);
            if (!handler) {
                throw new unilib_error_1.default(`${this.constructor.name}.dispatch/UNREGISTERED_HANDLER`, { context: { name } });
            }
            return handler(...parameters);
        });
    }
}
exports.UDispatcher = UDispatcher;
exports.default = UDispatcher;
